<script>
import MottoIcon from '@components/motto-icon.vue'

export default {
  components: {
    MottoIcon,
  },
  props: {
    textToCopy: {
      type: String,
      required: true,
    },
    toastMessage: {
      type: String,
      default: 'Link copied to clipboard.',
    },
    icon: {
      type: String,
      default: 'Clip',
    },
    theme: {
      type: String,
      default: 'round',
    },
    noIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      messageLinkCopied: false,
      timeOnScreen: 3000,
    }
  },
  methods: {
    copyLinkToClipboard() {
      const el = document.createElement('textarea')
      el.value = this.textToCopy
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      this.$refs.clipboardButton.appendChild(el)
      const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      this.$refs.clipboardButton.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      this.showToast()
    },

    showToast() {
      const h = this.$createElement
      const vNodesMsg = h(
        'h4',
        { class: ['color-white', 'mb-0', 'd-flex', 'justify-content-center', 'align-items-center'] },
        [
          h('MottoIcon', {
            props: {
              name: 'Copy',
              'icon-color': 'white',
            },
            class: 'mr-3',
          }),
          this.toastMessage,
        ]
      )
      this.$root.$bvToast.toast([vNodesMsg], {
        toaster: 'b-toaster-bottom-center',
        toastClass: ['toast-primary-blue', 'toast-body-100'],
        autoHideDelay: this.timeOnScreen,
      })
    },
  },
}
</script>

<template>
  <div ref="clipboardButton">
    <slot v-if="noIcon" />
    <template v-else>
      <BaseButton
        :options="{ defaultPadding: false }"
        :class="{
          [$style.clipboardButtonRound]: theme === 'round',
          [$style.clipboardButtonSquare]: theme === 'square',
        }"
        theme="white"
        @click="copyLinkToClipboard">
        <MottoIcon :name="icon" icon-color="gray" />
      </BaseButton>
    </template>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.clipboardButtonRound {
  width: 40px;
  min-width: 40px;
  height: 40px;
  padding: 0;
  cursor: pointer;
}

.clipboardButtonSquare {
  width: 30px;
  min-width: 30px;
  height: 30px;
  min-height: 30px;
  padding: 0;
  cursor: pointer;
  border-radius: 8px;
}

.toast {
  display: inline-block;
}
</style>
